import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function BonusesSection() {
  const bonuses = [{
    title: 'Bonus 1: Calendario Productivo Anual',
    desc: "La guía definitiva mes a mes para tu región. Nunca más te preguntes '¿qué planto ahora?'.",
    image: 'https://cdn.magicpatterns.com/uploads/vUcE4mDX7HfectPv6eGB6F/ChatGPT_Image_24_feb_2026,_15_07_39.png'
  }, {
    title: 'Bonus 2: Fertilizantes Naturales & Bioinsumos',
    desc: 'Recetas caseras para nutrir tu suelo sin gastar una fortuna en productos químicos.',
    image: 'https://cdn.magicpatterns.com/uploads/1g2JeP8HNTtA4mec5Q3TkZ/ChatGPT_Image_24_feb_2026,_15_07_54.png'
  }, {
    title: 'Bonus 3: Mini Invernadero Low Cost',
    desc: 'Construye tu propio invernadero con materiales económicos y protege tu huerta del frío.',
    image: 'https://cdn.magicpatterns.com/uploads/kMza1fkLJ7YH8jY572FLV9/ChatGPT_Image_24_feb_2026,_15_51_19.png'
  }];
  return <section className="py-20 px-4 bg-black relative overflow-hidden" data-id="element-26">
      <div className="max-w-7xl mx-auto relative z-10" data-id="element-27">
        <div className="text-center mb-16" data-id="element-28">
          <motion.span animate={{
          scale: [1, 1.05, 1]
        }} transition={{
          duration: 2,
          repeat: Infinity
        }} className="inline-block px-4 py-1 rounded-full bg-red-600 text-white font-bold text-sm mb-6 shadow-[0_0_15px_rgba(220,38,38,0.5)]" data-id="element-29">
            GRATIS POR HOY
          </motion.span>
          <h2 className="text-3xl sm:text-5xl font-bold text-white mb-6" data-id="element-30">
            Llévate estos 3 Regalos Exclusivos
          </h2>
          <p className="text-xl text-zinc-400 max-w-2xl mx-auto" data-id="element-31">
            Herramientas complementarias diseñadas para acelerar tus resultados
            desde el día 1.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-32">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.2
        }} viewport={{
          once: true
        }} className="bg-zinc-900 rounded-2xl overflow-hidden border border-zinc-800 flex flex-col" data-id="element-33">
              <div className="relative h-64 overflow-hidden bg-zinc-800 p-4" data-id="element-34">
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-contain opacity-90 hover:opacity-100 hover:scale-105 transition-all duration-500" data-id="element-35" />
                <div className="absolute top-4 right-4 bg-green-600 text-white text-xs font-bold px-3 py-1 rounded-full flex items-center gap-1 shadow-lg" data-id="element-36">
                  <Gift className="w-3 h-3" data-id="element-37" />
                  INCLUIDO
                </div>
              </div>
              <div className="p-6 flex-1 flex flex-col" data-id="element-38">
                <h3 className="text-xl font-bold text-white mb-3" data-id="element-39">
                  {bonus.title}
                </h3>
                <p className="text-zinc-400 text-sm leading-relaxed" data-id="element-40">
                  {bonus.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}